import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ETabsActions } from '../../constants/actionTypes/tabs';
import { ETabs } from '../../types/redux/tabs';

export const setActiveTab = actionGenerator<ETabsActions.SET_ACTIVE_TAB, ETabs>(ETabsActions.SET_ACTIVE_TAB);

export type TSetActiveTabAction = ReturnType<typeof setActiveTab>;

export type TTabsActions = TSetActiveTabAction;
